import React, {Component} from 'react'
import PropTypes from 'prop-types'
import FileItem from './FileItem'

class FilesList extends Component {
    render() {
        const {originalFiles, ...rest} = this.props

        return originalFiles.map(file => <FileItem key={file._id} {...rest} file={file}/>)
    }
}

FilesList.propTypes = {
    originalFiles: PropTypes.array.isRequired,
}

export default FilesList
